import { Actions, createEffect} from '@ngrx/effects';
import { Injectable, NgZone } from '@angular/core';
import { withLatestFrom, map, switchMap, catchError} from 'rxjs/operators';
import * as AuthActions from './auth.actions';
import { Router } from '@angular/router';
import { of, from as fromPromise } from 'rxjs';
import { AppState } from '../../store/app.reducers';
import { Store } from '@ngrx/store';
import { ofType } from '@ngrx/effects';
import { HttpClient } from "@angular/common/http";
import { signinGlobalVariables } from "../../shared/signinGeneral.service";

@Injectable()
export class AuthEffects {
  isAdmin = false;
  creation_date = new Date();
  token = '';

  authSignin = createEffect(() => this.actions$
    .pipe(ofType(AuthActions.LOGIN_START))
    .pipe(map((action: AuthActions.LoginStart) => {
      return action.payload;
    }))
    .pipe(withLatestFrom(this.store$))
    .pipe(switchMap(([data, appState]) => {
      if (appState.auth.redirectTo === null) {
        this.store$.dispatch(new AuthActions.SetRedirect(''));
      }
      return fromPromise(this.httpClient.post('aauth/signInWithEmailAndPassword', {
        email: data.email,
        password: data.password
      }).pipe(map(ans => {
          if (ans['ok']) {
            this.isAdmin = ans['isAdmin'];
            this.creation_date = ans['creation_date'];
            this.token = ans['token'];
            if (ans['force_password_change']) {
              this.router.navigate(['/a/password-change']).then();
              return new AuthActions.Force_Change_Password({user: ans['user'], msg: ans['msg']})
            } else {
              this.redirectToMainApp();
              return new AuthActions.LoginSuccess();
            }
          } else {
            return new AuthActions.LoginError({error: 'Wrong user or invalid password'});
          }
        }
      )));
    })));

  authSilentSignin = createEffect(() => this.actions$
    .pipe(ofType(AuthActions.SILENT_LOGIN_SUCCESS))
    .pipe(map((action: AuthActions.SilentLoginSuccess) => {
      return action.payload;
    }))
    .pipe(map(() => {
      this.redirectToMainApp();
      return new AuthActions.LoginSuccess();
    }))
    .pipe(catchError(() => {
      return of(new AuthActions.LoginError({error: 'Wrong user or invalid password'}));
    })));

  redirectToMainApp() {
    this._ngZone.run(()=>{
      window.location.href = window.location.origin + '/app/' + signinGlobalVariables['additional_parameters'];
    });
  }

  changePassword = createEffect(() => this.actions$
    .pipe(ofType(AuthActions.FORCE_CHANGE_PASSWORD))
    .pipe(map((action: AuthActions.Force_Change_Password) => {
      return action.payload;
    }))
    .pipe(map((data) => {
      if (data) {
        return new AuthActions.StartPasswordReset(data);
      }
      return null;
    })));

  constructor(private actions$: Actions, private router: Router,
              private store$: Store<AppState>,
              private httpClient: HttpClient,private _ngZone: NgZone
  ) {}
}
